import { event } from 'jquery'
import React,{useState,useEffect} from 'react'
import {Form,Col} from 'react-bootstrap'
function YesNoDrop(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled?true:false)
    const handleChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    useEffect(()=>{
        setDisabled(props.disabled)
    },[props.disabled])
    return(
        <Form.Group as={Col}>
            <Form.Label>{props.title}</Form.Label>
            <Form.Control as={"select"} name={props.name}  onChange={handleChange} value={value} disabled={disabled}>

                <option></option>
                <option> Yes</option>
                <option> No</option>
                <option>N/A</option>
                

            </Form.Control>
        </Form.Group>
    )
}
YesNoDrop.defaultProps = {
    name:"",
    title:"",
    
}
function CustomDrop(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(false)
    const handleChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    useEffect(()=>{
        setDisabled(props.disabled)
    },[props.disabled])
    return(
        <Form.Group as={Col}>
            <Form.Label>{props.title}</Form.Label>
            <Form.Control as={"select"} name={props.name} required={props.name=='gender'?true:false} onChange={handleChange} value={value} disabled={disabled}>

                {props.options.map((op,i)=>(
                    <option key={i}>{op}</option>
                ))}

            </Form.Control>
        </Form.Group>
    )
}
CustomDrop.defaultProps = {
    name:"",
    title:"",
    options:[],
    
    
}
function NumInput(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled?true:false)
    const handleChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    return(
        <Form.Group as={Col}>
        <Form.Label>{props.title}</Form.Label>
        <Form.Control type={'number'} name={props.name} onChange={handleChange} value={value} disabled={disabled}  >


        </Form.Control>
    </Form.Group>

    )
}
function TextInput(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled?true:false)
    const handleChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    return(
        <Form.Group as={Col}>
        <Form.Label>{props.title}</Form.Label>
        <Form.Control type={'text'} name={props.name}  onChange={handleChange} value={value} placeholder={props.placeholder} disabled={disabled}>


        </Form.Control>
    </Form.Group>

    )
}
TextInput.defaultProps = {
    name:"",
    title:"",
    placeholder:"",
    val:""
}
function DateInput(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled?true:false)
    const handleChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    return(
        <Form.Group as={Col}>
        <Form.Label>{props.title}</Form.Label>
        <Form.Control type={'date'} name={props.name} onChange={handleChange} value={value} disabled={disabled}>
        </Form.Control>
    </Form.Group>
    )
}
DateInput.defaultProps = {
    name:"",
    title:"",
    val:""
}
function Diagnosis(props){
    const [value,setVal] = useState(props.val!=null?props.val[props.name]:"")
    const [disabled,setDisabled] = useState(props.disabled?true:false)
    const [showSec,setShowSec] = useState(props.disabled?true:false)
    const [useInput,setInput] = useState(false)
    const [valSec,setValsec] =  useState(props.val!=null?props.val['other_'+props.name]:"")
    const handleChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    useEffect(()=>{
        if(value =="Other" && props.disabled ==false ){
            setShowSec(false)
            setInput(true)
        }
        else if(showSec && props.disabled ==false){
            setValsec("")
            setShowSec(true)
            let e = {}
            e.name = 'other_'+props.name
            e.value = null
            props.handler(e)
        }
        
    },[value])
  const   handleSecVal =(event) =>{
        setValsec(event.target.value)
        props.handler(event)
    }
    
    return(
        <>
        <Form.Group as={Col}>
        <Form.Label>{props.title}</Form.Label>
        <Form.Control as={'select'} name={props.name}  onChange={handleChange} value={!useInput ? value:undefined}  disabled={disabled}>
            <option></option>
            <option>Parkinson’s disease</option>
            <option>Atypical parkinsonism</option>
            <option>Parkinsonism</option>
            <option>PSP</option>
            <option>CBS</option>
            <option>MSA</option>
            <option>Essential tremor</option>
            <option>Dystonic tremor</option>
            <option>Normal pressure hydrocephalus</option>
            <option>Dementia</option>
            <option>Other</option>

        </Form.Control>

    </Form.Group>
    <Form.Group as={Col}>
        <Form.Label>Please specify</Form.Label>
        <Form.Control type={'text'} onChange={handleSecVal} name={'other_'+props.name} value={valSec} disabled={showSec}/>
    </Form.Group>
    </>
    )
}


function CustomDropWithExtras(props) {
    const [value, setVal] = useState(
      props.val != null ? props.val[props.name] : ''
    );
    const [disabled, setDisabled] = useState(props.disabled ? true : false);
  
    // Compute extrasEnabled directly without using state
    const extrasEnabled = value === props.triggerValue && !disabled;
  
    // State for extra fields
    const [dateValue, setDateValue] = useState(
      props.val != null ? props.val[props.dateName] : ''
    );
    const [text1Value, setText1Value] = useState(
      props.val != null ? props.val[props.text1Name] : ''
    );
    const [text2Value, setText2Value] = useState(
      props.val != null ? props.val[props.text2Name] : ''
    );
  
    // Update disabled state
    useEffect(() => {
      setDisabled(props.disabled);
    }, [props.disabled]);
  
    // Update value and extra fields when props.val changes
    useEffect(() => {
      const newValue = props.val != null ? props.val[props.name] : '';
      setVal(newValue);
  
      setDateValue(props.val != null ? props.val[props.dateName] : '');
      setText1Value(props.val != null ? props.val[props.text1Name] : '');
      setText2Value(props.val != null ? props.val[props.text2Name] : '');
    }, [props.val]);
  
    // Handle change in main dropdown
    const handleChange = (event) => {
      const selectedValue = event.target.value;
      setVal(selectedValue);
      props.handler(event);
  
      if (selectedValue !== props.triggerValue) {
        // Clear the values of extra fields and notify parent
        if (dateValue !== '') {
          setDateValue('');
          props.handler({ target: { name: props.dateName, value: '' } });
        }
        if (text1Value !== '') {
          setText1Value('');
          props.handler({ target: { name: props.text1Name, value: '' } });
        }
        if (text2Value !== '') {
          setText2Value('');
          props.handler({ target: { name: props.text2Name, value: '' } });
        }
      }
    };
  
    // Handle changes in extra fields
    const handleDateChange = (event) => {
      setDateValue(event.target.value);
      props.handler(event);
    };
  
    const handleText1Change = (event) => {
      setText1Value(event.target.value);
      props.handler(event);
    };
  
    const handleText2Change = (event) => {
      setText2Value(event.target.value);
      props.handler(event);
    };
  
    return (
      <>
        <Form.Group as={Col}>
          <Form.Label>{props.title}</Form.Label>
          <Form.Control
            as={'select'}
            name={props.name}
            onChange={handleChange}
            value={value}
            disabled={disabled}
          >
            {props.options.map((op, i) => (
              <option key={i}>{op}</option>
            ))}
          </Form.Control>
        </Form.Group>
  
        {/* The extra fields are always displayed but may be disabled */}
        <Form.Group as={Col}>
          <Form.Label>{props.dateLabel}</Form.Label>
          <Form.Control
            type="date"
            name={props.dateName}
            onChange={handleDateChange}
            value={dateValue}
            disabled={!extrasEnabled || disabled}
          />
        </Form.Group>
  
        <Form.Group as={Col}>
          <Form.Label>{props.text1Label}</Form.Label>
          <Form.Control
            type="text"
            name={props.text1Name}
            onChange={handleText1Change}
            value={text1Value}
            disabled={!extrasEnabled || disabled}
          />
        </Form.Group>
  
        <Form.Group as={Col}>
          <Form.Label>{props.text2Label}</Form.Label>
          <Form.Control
            type="text"
            name={props.text2Name}
            onChange={handleText2Change}
            value={text2Value}
            disabled={!extrasEnabled || disabled}
          />
        </Form.Group>
      </>
    );
  }

CustomDropWithExtras.defaultProps = {
  name: '',
  title: '',
  options: [],
  triggerValue: '',
  dateName: 'dateField',
  dateLabel: 'Date',
  text1Name: 'textField1',
  text1Label: 'Text Field 1',
  text2Name: 'textField2',
  text2Label: 'Text Field 2',
  required: false,
  disabled: false,
  handler: () => {},
  val: null,
};

// export { CustomDropWithExtras };



export  {YesNoDrop,NumInput,CustomDrop,TextInput,DateInput,Diagnosis,CustomDropWithExtras}